// extracted by mini-css-extract-plugin
export default {"container":"Pfiqq_YtQWi8KlcdXePo","featuresGrid":"b6krxTjqumEcW8RSPz5B","featureCard":"o_jZushWj7Ui7BGcK4f1","title":"B1mar_E9VKpBY6eaIYeW","description":"gjwFKRIelieEfunlKS5a"};